<div class="modal fade show d-block" tabindex="-1" role="dialog" (click)="onBackdropClick($event)">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content rounded-4 shadow border-0">
            <div class="modal-header border-0 pb-0">
                <h5 class="modal-title d-flex align-items-center gap-2">
                    <span class="material-symbols-outlined text-colonial">badge</span>
                    Editar usuario
                </h5>
                <button type="button" class="btn-close" (click)="onCancel()"></button>
            </div>

            <div class="modal-body">
                <form [formGroup]="form">
                    <div class="row g-3">
                        <div class="col-12 col-md-6">
                            <label for="employeeName" class="form-label">Nombre <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" id="employeeName" formControlName="name">
                        </div>

                        <div class="col-12 col-md-6">
                            <label for="employeeLastName" class="form-label">Apellido <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" id="employeeLastName" formControlName="lastName">
                        </div>

                        <div class="col-12">
                            <label for="employeeBranch" class="form-label">Sucursal <span class="text-danger">*</span></label>
                            <select class="form-select" id="employeeBranch" formControlName="branchId">
                                <option [ngValue]="null" disabled>Selecciona una sucursal</option>
                                <option *ngFor="let branch of branches" [ngValue]="branch.branchId">
                                    {{ branch.name }} ({{ branch.bank?.name }})
                                </option>
                            </select>
                        </div>

                        <div class="col-12" *ngIf="!isManagerRole">
                            <label for="employeeManager" class="form-label">Gerente</label>
                            <select class="form-select" id="employeeManager" formControlName="managerId"
                                [attr.disabled]="loadingManagers ? true : null">
                                <option [ngValue]="null">
                                    {{ managers.length ? 'Sin gerente asignado' : 'Sin gerentes activos en esta sucursal' }}
                                </option>
                                <option *ngFor="let manager of managers" [ngValue]="manager.id">
                                    {{ manager.name }} {{ manager.lastName }}
                                </option>
                            </select>
                            <small class="text-muted">Solo se listan gerentes activos de la sucursal seleccionada.</small>
                        </div>
                    </div>
                </form>
            </div>

            <div class="modal-footer border-0">
                <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">Cancelar</button>
                <button type="button" class="btn bg-colonial btn-secondary" (click)="onSave()"
                    [disabled]="form.invalid">
                    Guardar cambios
                </button>
            </div>
        </div>
    </div>
</div>
<div class="modal-backdrop fade show"></div>
